import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0456e882&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0456e882')) {
      api.createRecord('0456e882', component.options)
    } else {
      api.reload('0456e882', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0456e882&", function () {
      api.rerender('0456e882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/index.vue"
export default component.exports